// Toast region for the customer portal chrome.
//
// `createToastFn(region)` returns a function that pushes a toast into the
// region element. Toasts auto-dismiss after 3.5s and stack vertically
// (newest at the bottom). Used as `SectionContext.showToast`.

import type { ToastKind } from "../types";

const DISMISS_MS = 3500;
const FADE_MS = 220;

/** Create the function sections call to display a toast. */
export function createToastFn(
  region: HTMLElement,
): (msg: string, kind?: ToastKind) => void {
  return (msg, kind = "info") => {
    const toast = document.createElement("div");
    toast.className = `cust-toast cust-toast-${kind}`;
    toast.setAttribute("role", kind === "error" ? "alert" : "status");
    toast.textContent = msg;
    region.appendChild(toast);

    const removeAfterFade = (): void => {
      toast.style.transition = `opacity ${FADE_MS}ms ease-out, transform ${FADE_MS}ms ease-out`;
      toast.style.opacity = "0";
      toast.style.transform = "translateX(20px)";
      window.setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, FADE_MS);
    };

    window.setTimeout(removeAfterFade, DISMISS_MS);
  };
}

/** Build the live region element. Insert into the document; returns the node. */
export function buildToastRegion(): HTMLElement {
  const region = document.createElement("div");
  region.className = "cust-toast-region";
  region.setAttribute("aria-live", "polite");
  region.setAttribute("aria-atomic", "false");
  return region;
}
